import { Card, CardContent } from '@/components/ui/card';
import { formatDate, formatCurrencyNoDecimals } from '@/utils/formatters';
import { Calendar } from 'lucide-react';
import type { InvestorDistributionDetail } from '../services/distributions-service';

interface DistributionDetailProps {
  distribution: InvestorDistributionDetail;
}

export function DistributionDetail({ distribution }: DistributionDetailProps) {
  return (
    <div className="space-y-4">
      {/* Header Card - Fund, Date */}
      <Card>
        <CardContent className="pt-4 pb-4">
          <div className="mb-3">
            <h3 className="font-semibold text-lg">{distribution.fund_name}</h3>
            {distribution.description && (
              <p className="text-sm text-muted-foreground">
                {distribution.description}
              </p>
            )}
          </div>

          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <div className="flex items-center gap-1.5">
              <Calendar className="h-4 w-4" />
              <span>
                Distribution date: {formatDate(distribution.distribution_date)}
              </span>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Amount Card */}
      <Card>
        <CardContent className="pt-4 pb-4">
          <div className="text-sm text-muted-foreground mb-1">
            Your Distribution Amount
          </div>
          <div className="text-2xl font-semibold">
            {formatCurrencyNoDecimals(distribution.investor_amount)}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
